import { SubscriptionWithPaidFeatures } from '../../../projects/client';

export const demoSettingsConfigStorageKey = 'demoSettingsConfig';
export interface DemoSettingsState {
  subscriptionWithPaidFeatures: SubscriptionWithPaidFeatures[];
}
